<template>
  <div class="account-message">
    <div class="list-group list-group-flush">
      <div class="card-header bg-default">
        {{ accountMessage.name }}
        <template v-for="messageType in accountMessage.type">
          <span class="badge" :key="messageType" :class="randomLabel(messageType)">{{ messageType }}</span>
        </template>
      </div>
      <div class="list-group-item">
        <strong>Account Types:</strong>
        <template v-for="accountType in accountMessage.AccountTypes">
          <span class="badge mr-2" :key="accountType.uuid" :class="randomLabel(accountType.name)">{{ accountType.name }}</span>
        </template>
      </div>
      <div class="list-group-item">
        <strong>Message Active Times:</strong>
        {{ accountMessage.startTime | short_date_time_format }} - {{ accountMessage.endTime | short_date_time_format }}
      </div>
      <div class="list-group-item" v-html="accountMessage.message"></div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-sm btn-warning"
      :to="{ path: `/membership/messages/edit/${accountMessage.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-sm btn-danger" @click="delMessage(accountMessage)">
        <span class="fa fa-trash-alt"></span> Delete
      </button>
    </div>
  </div>
</template>

<script>
import {
  DELETE_ACCOUNT_MESSAGE
} from '@/vuex/types'
import { randomLabel } from '@/util/helpers'
import { mapActions } from 'vuex'
export default {
  name: 'AccountMessage',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    accountMessage () {
      return {
        startTime: new Date(),
        endTime: new Date(),
        message: '',
        name: '',
        ...this.object
      }
    }
  },
  methods: {
    async executeAction (action, payload) {
      await this[action](payload)
    },
    delMessage (message) {
      this.executeAction(DELETE_ACCOUNT_MESSAGE, message)
    },
    randomLabel,
    ...mapActions([
      DELETE_ACCOUNT_MESSAGE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/AccountMessage.vue